import React from "react";
import { Button, Form } from "react-bootstrap";
import "./PageTwo.css";
import { fadeInLeft, fadeInRight } from 'react-animations';
import Radium, { StyleRoot } from 'radium';
import { BiRupee } from "react-icons/bi";
import { useState } from "react";
// import DatePicker from "react-datepicker";
import DatePicker from 'react-date-picker';
import moment from "moment";
import loader from '../../assets/img/loader.gif';

const styles = {
  fadeInLeft: {
    animation: 'x 3s',
    animationName: Radium.keyframes(fadeInLeft, 'fadeInLeft')
  },
  fadeInRight: {
    animation: 'x 3s',
    animationName: Radium.keyframes(fadeInRight, 'fadeInRight')
  }
}
const PageTwo = (props) => {
  // const [startDate, setStartDate] = useState(new Date());
  // const [value, onChange] = useState(new Date());
  const [date, setDate] = useState(new Date())
  const { onPageNumberClick, formik, handleDateChange, isloader } = props;


  // var today = new Date();
  // today.setDate(today.getDate());
  // var Today = today.toISOString().substr(0, 10);

  return (
    <StyleRoot>
      <main
        className="pt5 black-80 center"
      >
        <div className="container">
          <div className="row justify-content-center">
            {/* <div className="col-lg-6">
            <div className="postatask-img">
              <img src={postatask} alt='' className="img-fluid" />
            </div>
          </div> */}
            <div className="col-lg-6" style={styles.fadeInLeft}>
              <div className="post-tasks-main postatask-main">
                <div className="post-tasks">
                  <h5 className="post-tasks-title">Budget</h5>
                </div>

                <Form.Group className="mb-3 inr-ruppee" controlId="formBasicEmail">
                  <Form.Label>What's your budget?<span style={{ color: "#db3131" }}>*</span></Form.Label>
                  <BiRupee className="budget" size="20" style={{ color: "#000" }} />
                  <Form.Control
                    type="text"
                    name="budget"
                    onChange={formik.handleChange}
                    maxLength="40"
                    placeholder=" Enter your budget "
                    style={{ paddingLeft: "20px" }}

                  />
                </Form.Group>

                {/* <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                  <Form.Label>When do you need it done?</Form.Label>
                  <Form.Control
                    type="date"
                    name="date"
                    onChange={formik.handleChange}
                    min={date}
                  />
                </Form.Group> */}
                {/* <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                  <Form.Label>When do you need it done?</Form.Label>
                  <DatePicker
                    className="form-control"
                    name="date"
                    selected={date}
                    onChange={(date: Date) => setDate(date)}
                  />
                </Form.Group> */}
                <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                  <Form.Label>When do you need it done?<span style={{ color: "#db3131" }}>*</span></Form.Label>
                  <DatePicker
                    className="form-control"
                    calendarAriaLabel="Toggle calendar"
                    clearAriaLabel="Clear value"
                    dayAriaLabel="Day"
                    monthAriaLabel="Month"
                    nativeInputAriaLabel="Date"
                    name="date"
                    clearIcon={false}// onChange={formik.handleChange}
                    onChange={(e) => { handleDateChange(e) }}
                    value={formik.values.date}
                    yearAriaLabel="Year"
                    // minDate={date}
                    minDate={date}
                    clearButtonClassName={"d-clear-none"}

                  />
                </Form.Group>
                <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                  <Form.Label>Select Time Slot<span style={{ color: "#db3131" }}>*</span></Form.Label>
                  <div className="middle">
                    <label>
                      <input type="radio" value="1" name="time_slot" onChange={formik.handleChange} />
                      <div className="front-end box">
                        <span>Before 10 AM</span>
                      </div>
                    </label>

                    <label>
                      <input type="radio" name="time_slot" value="2" onChange={formik.handleChange} />
                      <div className="front-end box">
                        <span>10 AM - 2 PM</span>
                      </div>
                    </label>
                    <label>
                      <input type="radio" name="time_slot" value="3" onChange={formik.handleChange} />
                      <div className="front-end box">
                        <span>2 PM - 6 PM</span>
                      </div>
                    </label>

                    <label>
                      <input type="radio" name="time_slot" value="4" onChange={formik.handleChange} />
                      <div className="front-end box">
                        <span>After 6 PM</span>
                      </div>
                    </label>
                  </div>
                </Form.Group>

                <div className='post-task-btn mt-4'>
                  {isloader == true ?
                    <div className='loader'>
                      <img src={loader} alt="" />
                    </div>
                    :
                    <Button type="submit" className="btn btn-primary">Next</Button>
                  }
                </div>

              </div>
            </div>
          </div>
        </div>
      </main>
    </StyleRoot>
  );
}

export default PageTwo;